define([
  "require",
  "jquery",
  "wcs.utils",
  "wcs.context",
  "jquery.tooltipster",
  "s7-imageset-name-parser"
], function(require, $, utils, ctx) {
  // Name the plugin
  var PLUGIN_IDENTIFIER = "productForm";
  var DEBUG = false;

  // Create the function that will be bound to JQuery
  var vfdpPlugin = function(element, options) {
    this.element = element;
    this.options = options;
  };

  // Define the plugin's prototype and defaults
  vfdpPlugin.prototype = {
    defaults: {
      dataInput: "data-product-form-options"
    },

    /**
     * Initializes the plugin instance
     * @returns {Object} This plugin instance
     */
    init: function() {
      var self = this;

      if (DEBUG)
        console.debug(
          "Initializing ",
          PLUGIN_IDENTIFIER,
          "on",
          $(self.element)
        );

      // Merge various methods of providing plugin options into a single config object
      self.metadata = $(self.element).data(PLUGIN_IDENTIFIER + "Options");
      self.config = $.extend(
        {}, // empty object to merge into
        self.defaults, // defaults hardcoded into the prototype defined in this file
        self.options, // options provided when initializing by JQuery $(selector).myPlugin(options)
        self.metadata // options provided as HTML data attribute $(selector).data()
      );

      // Initialize events
      self.events();

      // Do any DOM manipulation or other setup
      if ($(".product-form-js").length) {
        self.initProductForm(document);
      }

      // Allow JQuery-style chaining of the plugin
      return self;
    },

    /**
     * Binds plugin events
     **/
    events: function() {
      var self = this;

      $(document).on("QUICKSHOP_DISPLAY", function(e) {
        var quickshopDisplayExecuted = false;
        return function(e) {
          if(!quickshopDisplayExecuted) {
            quickshopDisplayExecuted = true;
            self.initProductForm(e.target);
          }
        };
      });
    },

    initProductForm: function(container) {
      var $productFormTooltip = $("#product-form section.tooltip-js");
      // Shortcut to check if a node exists
      function exists(selector, scope) {
        scope = scope || document;
        return $(selector, $(scope)).length > 0;
      }

      // Run through a list of conditions to detect the product form type
      var updateCartButton = ".shopcart-update-js",
        onlineExchangeButton = ".shopcart-exchange-js",
        modal = ".quickview-box-js",
        templateType = WCS_CONFIG.get("PDP::pdpTemplateType"),
        $container = $(container) || $(document),
        $productForm = $(".product-form-js"),
        isShopTheLook =
          $("body.catalog.bundle, body.catalog.bundle-detail-page-js").length >
          0,
        isModal = exists(modal),
        isCartEdit = isModal && exists(updateCartButton, modal),
        isOnlineExchange = isModal && exists(onlineExchangeButton, modal),
        isQuickView = isModal && !isCartEdit && !isOnlineExchange,
        isPDP = !isModal && $("body").data("page-type") === "pdp",
        token = utils.getURLParam(window.location.href, "token"),
        isRedeemGiftPdp =
          $(".product-form-js").data("redeem-gift-enabled") && token.length > 0,
        cashStar = $(".give-as-gift-link-js");

      // Is this the Edit modal launched from the cart?
      if (isCartEdit) {
        require(["wcs.product-form-update-item"], function() {
          $productForm.UpdateItemForm();
        });
      }

      // Is this the Online Exchange modal?
      if (isOnlineExchange) {
        require(["wcs.product-form-exchange-item"], function() {
          $productForm.ExchangeItemForm();
        });
      }

      // are we on PDP?
      // is this the QuickView?
      if (isPDP || isQuickView || isShopTheLook) {
        require(["wcs.product-form-add-to-cart"], function() {
          $productForm.AddToCartForm();
        });
      }

      // is this a Colorway bundle? -- OLD PDP template - for Vans and TBL
      if (
        $productForm.length > 0 &&
        (templateType === "basic" || templateType === "drawer")
      ) {
        require(["wcs.product-form-colorway-events"], function() {
          $productForm.ColorwayBundleEvents();
        });
      }

      // attach form event handlers for platform pdp swatches
      if (templateType === "swatches" && $productForm.length > 0) {
        require(["wcs.product-form-pdpswatches-events"], function() {
          $productForm.PDPSwatchesEvents();
        });
      }

      // buy from online dealer - only load if config is set to true and not in quick view
      if (
        WCS_CONFIG.get("PDP::authOnlineDealerEnabled") === true &&
        !isQuickView &&
        !isRedeemGiftPdp
      ) {
        require(["wcs.product-form-online-dealers"], function() {
          $container.find(".online-dealer-js").OnlineDealers();
        });
      }

      // Detail section for swatches only
      if (templateType === "swatches" && $productForm.length > 0) {
        require(["wcs.product-form-detail"]);
      }

      // init context change handlers
      if ($(".context-trigger-js").length > 0) {
        require(["wcs.product-form-context"]);
      }

      // find in store
      if ($("#find-store-container").length > 0) {
        require(["wcs.find-in-store"]);
      }

      //product details drawer
      if (
        !isShopTheLook &&
        (templateType === "drawer" || templateType === "swatches") &&
        $productForm.length > 0
      ) {
        require(["wcs.product-form-drawer"]);
      }

      // disabled duplicate tooltipster
      if ($productFormTooltip.data("tooltipster-ns")) {
        ($productFormTooltip, $container).tooltipster("disable");
      }

      // Check if the current page is the PDP and HTML5 history is supported
      if (isPDP) require(["wcs.product-form-html5history"]);

      // Initialize Cashstar
      if (cashStar.length > 0) {
        require(["shared.cashstar"], function() {
          var $giveAsGiftLink = cashStar,
          $giveAsGiftData = $giveAsGiftLink.data();

          $giveAsGiftLink.on("click", function(event) {
            event.preventDefault();
            window.cstar.openPbg({
              appUrl: $giveAsGiftData.appurl,
              modalZIndex: $giveAsGiftData.modalzindex,
              productId: $giveAsGiftData.productid,
              productBrandName: $giveAsGiftData.productbrandname,
              productName: $giveAsGiftData.productname,
              productUrl: $giveAsGiftData.producturl,
              productImageUrl: $giveAsGiftData.productimageurl,
              productImageWidth: $giveAsGiftData.productimagewidth,
              productImageHeight: $giveAsGiftData.productimageheight,
              productCategory: $giveAsGiftData.productcategory,
              productOriginalPrice: $giveAsGiftData.productoriginalprice,
              productDiscountedPrice: $giveAsGiftData.productdiscountedprice,
              promoCode: $giveAsGiftData.promocode,
              languageCode: $giveAsGiftData.languagecode,
              currencyCode: $giveAsGiftData.currencycode,
              user: {
                id: $giveAsGiftData.user
              }
            });
          });
        });
      }

      // Initialize Loyalty message
      if (ctx.getUserType() == 'R') { // Is a registered user
        if (ctx.getLoyaltyOptIn() == '1') { // Is a loyalty member
          // Show loyalty member message
            $container.find('.product-loyalty-points-message.member').removeClass('hide');
        } else {
          // Valid user, but not a loyalty member. Show message and hide the 'learn more' link.
            $container.find('.product-loyalty-points-message:not(".member")').removeClass('hide').find('.loyalty-form-hopup').addClass('hide');
        }
      } else {
        // Not a registered user, show full message with 'learn more' link
          $container.find('.product-loyalty-points-message:not(".member")').removeClass('hide');
      }
    }// end function initProductForm
  };

  // Create the instance defaults from the prototype
  vfdpPlugin.defaults = vfdpPlugin.prototype.defaults;

  // Register as a JQuery plugin and prevent duplicate instantiation
  $.fn[PLUGIN_IDENTIFIER] = function(options) {
    return this.each(function() {
      var instance = $(this).data(PLUGIN_IDENTIFIER);
      if (!instance) {
        instance = new vfdpPlugin(this, options).init();
        $(this).data(PLUGIN_IDENTIFIER, instance);
      }
    });
  };
});
